import React from 'react'

const TabLabel = ({ active, label, subLabel }) => {
  return (
          <div className={ active ? 'active' : 'inactive'}>
            <p className="tab-text">{ label }</p>
            { subLabel &&
              <p className="tab-subtext"> {subLabel} </p>
            }
          </div> 
  )
}

export default TabLabel


// WEBPACK FOOTER //
// ./src/components/GetInvolved/TabLabel.js